import * as tslib_1 from "tslib";
import { ItemContainer } from './item_container';
var SlideVie = /** @class */ (function (_super) {
    tslib_1.__extends(SlideVie, _super);
    function SlideVie(param) {
        return _super.call(this, param) || this;
    }
    SlideVie.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "SlideVie" });
    };
    SlideVie.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return SlideVie;
}(ItemContainer));
export { SlideVie };
//# sourceMappingURL=slide_view.js.map